import {  Typography, TypographyProps } from '@mui/material';
export const TypographyComponent: React.FC<TypographyProps> = props => {
  return <Typography {...props}>{props.children}</Typography>;
};
